import React, { useEffect, useState } from "react";
import FillableForm from "./FillableForm";
import { GetTemplateFileByDescription } from "../../_api/documentsApi";
import Cookies from "universal-cookie";
import { Grid } from "@mui/material";
import { PageLoader } from "@/_components";
import PropTypes from "prop-types";
import { makeFieldsVisible, updateField } from "./FormHelpers";
import { getProfile } from "../../_api/profileApi";
// TODO : use location info
// import { getLocation } from "../../_api/appointmentApi";
// import { utilities } from "../../_helpers/utilities";

export default function PAElectronicPaperwork({
  userID,
  clientID,
  reportID,
  vehicleID,
  jurisdictionID,
  appointmentID,
  // locationID, // TODO : use location info
  handleClose,
  handleFormSaved,
  formDescription,
}) {
  const cookies = new Cookies();
  const user = cookies.get("lifesaferUser");
  const [templateFile, setTemplateFile] = useState(null);
  const [client, setClient] = useState(null);
  // TODO : Use location info
  // const [location, setLocation] = useState({});
  // function totalAddress(location) {
  //   let partOne = location.address1 != null ? location.address1 : "";
  //   let partTwo = location.address2 != null ? location.address2 : "";

  //   return `${partOne} ${partTwo}`;
  // }

  useEffect(() => {
    // TODO : Use location info
    // if (!location) {
    //   getLocation(locationID)
    //     .then((locationData) => {
    //       setLocation(locationData);
    //     })
    //     .catch((error) =>
    //       console.error("Error getting location data: ", error)
    //     );
    // }
    if (!client) {
      getProfile(clientID)
        .then((clientData) => {
          setClient(clientData[0]);
        })
        .catch((error) => {
          console.error("Error getting client data : ", error);
        });
    }
    if (!templateFile) {
      GetTemplateFileByDescription(user.languageID, "PA_DL_21")
        .then((document) => {
          setTemplateFile(
            `data:application/pdf;base64,${document.fileBase64Value}`
          );
        })
        .catch((error) =>
          console.error("Error getting template file: ", error)
        );
    }
  }, []);
  return (
    <div style={{ padding: 20, margin: 20 }}>
      {!templateFile && (
        <Grid
          container
          direction="column"
          alignItems="center"
          sx={{ marginTop: 5, paddingTop: 5 }}
        >
          <PageLoader />
        </Grid>
      )}
      {templateFile &&
        client && ( // && location
          <FillableForm
            handleClose={handleClose}
            formName="PA_DL_21.pdf"
            formDescription={formDescription}
            templateFile={templateFile}
            userID={userID}
            clientID={clientID}
            reportID={reportID}
            vehicleID={vehicleID}
            appointmentID={appointmentID}
            jurisdictionID={jurisdictionID}
            handleFormSaved={handleFormSaved}
            validationFunction={(viewer) => {
              // Assume all editable fields are required.
              let requiredFieldNames = [
                "Name",
                "DLNum",
                "Address",
                "City",
                "State",
                "ZipCode",
              ];
              let requiredFields = viewer.formFieldCollection.filter((field) =>
                requiredFieldNames.includes(field.name)
              );
              let requiredFieldsAreFilled = requiredFields.every(
                (field) =>
                  field.value !== "" &&
                  field.value !== null &&
                  field.value !== undefined
              );
              if (requiredFieldsAreFilled) {
                viewer.formFieldCollection.forEach((item) => {
                  viewer.formDesignerModule.updateFormField(item, {
                    backgroundColor: "transparent",
                  });
                });
              }
              if (requiredFieldsAreFilled) {
                return true;
              } else {
                return false;
              }
            }}
            fillingFunction={(data, viewer) => {
              // make sure all fields are light transparent blue
              makeFieldsVisible(viewer);
              // fill data and make readonly.
              let editableFields = [
                "Name",
                "DLNum",
                "Address",
                "City",
                "State",
                "ZipCode",
              ];
              for (let item in data) {
                let isEditable = true;
                if (editableFields.includes(item)) {
                  isEditable = false;
                }

                updateField(item, data[item], viewer, isEditable);
              }
            }}
            fillingData={{
              Name: `${client.firstName} ${client.lastName}`,
              Address: client.homeAddr1,
              City: client.city,
              State: client.state,
              ZipCode: client.zip,
              VendorName: "Lifesafer Interlock",
              PhoneNumber: "(717) 558-9184",
              VendorAddress: "1993 Hummel Ave. Suite 102",
              VendorCity: "Camp Hill",
              VendorState: "PA",
              VendorZipCode: "17011",
              // TODO : use location address
              // VendorName: location.displayName,
              // PhoneNumber: utilities.formatPhoneNumber(location.phone1),
              // VendorAddress: totalAddress(location),
              // VendorCity: location.city,
              // VendorState: location.state,
              // VendorZipCode: location.zip,
            }}
          />
        )}
    </div>
  );
}

PAElectronicPaperwork.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleFormSaved: PropTypes.func.isRequired,
  userID: PropTypes.number.isRequired,
  clientID: PropTypes.number.isRequired,
  jurisdictionID: PropTypes.number.isRequired,
  reportID: PropTypes.number.isRequired,
  vehicleID: PropTypes.number.isRequired,
  locationID: PropTypes.number.isRequired,
  appointmentID: PropTypes.number.isRequired,
  formDescription: PropTypes.string.isRequired,
};
